import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const getValidSliderValue = (
    val: number,
    step: number =  15,
    min: number = 0,
    max: number = 100
): number => {
  const nearest = Math.round(val / step) * step;

  return Math.min(Math.max(nearest, min), max);
};

export function capitalize(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
}

export function capitalizeEachUnderscore(str: string): string {
  return str
      .toLowerCase()
      .split('_')
      .map(word => word === 'ai' ? word.toUpperCase() : (word.charAt(0).toUpperCase() + word.slice(1)))
      .join(' ');
}

export function toUpperWithUnderscoreSpaces(str: string): string {
  return str
      .trim()
      .replace(/\s+/g, '_')
      .toUpperCase();
}